import React, { Component } from 'react';
import Header from '.././Header';
import ProjectCard from './ProjectCard';
import classnames from 'classnames';
import './style.sass';

export default class Projects extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    var work = [
      {title: "AngelList", subtitle: "I design and build products for a marketplace of recruiting startups and job seekers", timespan: "2016\u2014Now", slug: "angellist" },
      {title: "Quora", subtitle: "I worked on growth, notifications and content quality initiatives to share the world's knowledge", timespan: "2012\u20142015", slug: "quora" },
      {title: "Surveylicious", subtitle: "In school, I developed a mobile survey tool for businesses to collect feedback from customers", timespan: "2011\u20142012", slug: "surveylicious" },
    ]

    var projects = [
      {title: "PetsChamp", subtitle: "I built a marketplace to connect pet stores and aspiring pet owners in Singapore", timespan: "2016", slug: "petschamp" },
      {title: "Rainmakers", subtitle: "I organized startup panels for students and entrepreneurs at Stanford University", timespan: "2011", slug: "rainmakers" },
      {title: "sgBEAT", subtitle: "I cofounded a microblogging platform in Singapore with nearly 40K members", timespan: "2009\u20142010", slug: "sgbeat" },
      {title: "Tutorific", subtitle: "I started a private tutor agency to match college undergrads with middle school students", timespan: "2009", slug: "tutorific" },
    ]

    return (
      <div className={classnames('Projects', className)}>
        <Header />
        <div className="container">
          <div className="section">
            <div className="section-header">
              Work
            </div>
            <div className="Projects-projects">
              {
                Object.keys(work).map(function(project) {
                  var title = work[project]['title'];
                  var subtitle = work[project]['subtitle'];
                  var timespan = work[project]['timespan'];
                  var slug = work[project]['slug'];
                  return (
                    <ProjectCard
                      title={title}
                      subtitle={subtitle}
                      timespan={timespan}
                      slug={slug}
                    />
                  );
                })
              }
            </div>
          </div>
          <div className="section">
            <div className="section-header">
              Side Projects
            </div>
            <div className="Projects-projects">
              {
                Object.keys(projects).map(function(project) {
                  var title = projects[project]['title'];
                  var subtitle = projects[project]['subtitle'];
                  var timespan = projects[project]['timespan'];
                  var slug = projects[project]['slug'];
                  return (
                    <ProjectCard
                      title={title}
                      subtitle={subtitle}
                      timespan={timespan}
                      slug={slug}
                    />
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/index.js